import { set, get } from 'idb-keyval';

import { Feature } from './config';
import { gatewayApiAgent } from '../api/apiAgents';
import { Audiences } from '../api-types/director';

const CACHE_KEY = 'feature-flags-audiences';

export async function fetchFeatureAudiences(featureIds?: Feature[]) {
  try {
    const response = await gatewayApiAgent.get<Audiences>(
      '/director/public/v1/features/audiences',
      {
        params: { featureIds },
      },
    );

    await set(CACHE_KEY, response.data);
    return response.data;
  } catch (err) {
    const cachedFlags = await get<Audiences>(CACHE_KEY);

    if (!cachedFlags) {
      console.error(err);
      throw err;
    }

    return cachedFlags;
  }
}
